import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import { theme } from '@Guidelines/Theme/theme';
import SpeakerAssignmentMergeChoice from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/SpeakerAssignmentSidebar/SpeakerAssignmentMergeAction/SpeakerAssignmentMergeChoice';
import type TranscriptSpeakerView from '@UI/Store/Interviews/Views/TranscriptSpeakerView';
import { css } from '@emotion/react';
import type * as React from 'react';

const sectionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

const eyebrowStyle = css`
	${theme.typography.eyebrow}
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly facilityId: number;
	readonly subject: SubjectAddress;
	readonly interviewId: number;
	readonly source: TranscriptSpeakerView;
	readonly otherSpeakers: readonly TranscriptSpeakerView[];
};

/** "Fusionner avec…" (§9.5): renders nothing when this is the transcript's only speaker. */
const SpeakerAssignmentMergeAction: React.FC<Props> = ({
	facilityId,
	subject,
	interviewId,
	source,
	otherSpeakers,
}) => {
	if (otherSpeakers.length === 0) {
		return null;
	}

	return (
		<div css={sectionStyle}>
			<span css={eyebrowStyle}>Fusionner avec…</span>
			{otherSpeakers.map((target) => (
				<SpeakerAssignmentMergeChoice
					key={target.id}
					facilityId={facilityId}
					subject={subject}
					interviewId={interviewId}
					source={source}
					target={target}
				/>
			))}
		</div>
	);
};

export default SpeakerAssignmentMergeAction;
